var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { SHUFFLE_SVG } from "../../assets";
import { ListView, Box } from "..";
var RadioChartDetail = /** @class */ (function (_super) {
    __extends(RadioChartDetail, _super);
    function RadioChartDetail() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RadioChartDetail.prototype.render = function () {
        var _this = this;
        var set = this.props.set;
        return React.createElement(Box, { style: { padding: '40px', minHeight: '50vh' } },
            React.createElement("div", { className: "curated-detail" },
                React.createElement("div", { className: "curated-row" },
                    React.createElement("div", { className: "curated-img" },
                        React.createElement("div", { className: "set-img" },
                            React.createElement("img", { src: set.category.image_url }),
                            React.createElement("div", { className: "set-title-container" },
                                React.createElement("div", { className: "set-title" }, set.category.name))),
                        React.createElement("div", { className: "set-description" },
                            React.createElement("div", { className: "set-info" },
                                set.albums.length,
                                " Songs"),
                            React.createElement("div", { className: "set-shuffle", onClick: function () {
                                    _this.listView && _this.listView.play(true);
                                } },
                                React.createElement("div", null,
                                    "Shuffle ",
                                    React.createElement("img", { src: SHUFFLE_SVG, width: 15 }))))),
                    React.createElement("div", { className: "curated-list" },
                        React.createElement(ListView, __assign({ ref: function (ref) { return _this.listView = ref; } }, this.props, { enableDrag: this.props.enableDrag, noBox: true, contentType: 'mixed', albums: set.albums, context: 'curated-set', hide: { firstSeperator: true }, onAlbumSelected: this.props.onAlbumSelected, onArtistClick: this.props.onArtistClick, onMediaSelected: this.props.onMediaSelected, onMediaDownlod: this.props.onMediaDownlod, onAddToCrate: this.props.onAddToCrate, onRemoveFromCrate: this.props.onRemoveFromCrate }))))));
    };
    return RadioChartDetail;
}(React.PureComponent));
export default RadioChartDetail;
//# sourceMappingURL=RadioChartDetail.js.map


//////////////////
// WEBPACK FOOTER
// ./bpm-web-generic/lib/components/views/RadioChartDetail.js
// module id = 1298
// module chunks = 0